.axis,
.grid {
  overflow: visible;
  z-index: var(--h5w-zi-axisSystem);
  pointer-events: none; /* let events through to canvas */
}

.axis[data-type='abscissa'] {
  grid-area: bottom-axis;
}

.axis[data-type='ordinate'] {
  grid-area: left-axis;
  transform: translateX(100%);
}

.axis > g > line {
  stroke: var(--h5w-grid--color, gray);
  stroke-opacity: var(--h5w-grid--opacity, 0.33);
}

.tick > line {
  stroke: var(--h5w-ticks--color, gray);
}

.tick > text {
  fill: currentColor;
  color: var(--h5w-tickLabels--color, #333);
  font-family: var(--h5w-tickLabels--fontFamily, inherit);
  font-size: var(--h5w-tickLabels--fontSize, 0.75em);
  user-select: none; /* prevent unwanted selection during interaction */
}

.label {
  fill: currentColor;
  color: var(--h5w-axisLabels--color, #333);
  font-family: var(--h5w-axisLabels--fontFamily, inherit);
  font-size: var(--h5w-axisLabels--fontSize, inherit);
  font-weight: var(--h5w-axisLabels--fontWeight, 600);
  text-anchor: middle;
}

.grid {
  grid-area: canvas;
}

.grid line {
  stroke: var(--h5w-grid--color, gray);
  stroke-opacity: var(--h5w-grid--opacity, 0.33);
}
